import React from "react";
import styled from "@emotion/styled";
import { NavItem } from "../../NavHeader/NavItem";
import { GameCircle } from "../Games/GameCircle";
import { StoreButton } from "../../StoreButton";

import appLogo from "../../../images/app-icon.jpg";
import appStoreLogo from "../../../images/app-store.png";
import playStoreLogo from "../../../images/play-store.png";
import { BATTLERUSH_ARENA_APP_STORE_URL, BATTLERUSH_ARENA_GOOGLE_PLAY_STORE_URL, BATTLERUSH_ARENA_TITLE } from "../../../constants";
import { SMALL_DEVICES } from "../../../mediaQueries";

const Container = styled.div`
  width: calc(100% - 20px);
  min-height: 80vh;
  color: white;
  padding: 10px;
  font-size: 26px;
  display: flex;

  ${SMALL_DEVICES} {
    flex-direction: column;
    align-items: center;
  }
`;

const HightailGamesSection = styled.div`
  flex: 1.5;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${SMALL_DEVICES} {
    text-align: center;
  }
`;

const HightailGamesTitle = styled.div`
  font-size: 72px;
  text-transform: uppercase;

  ${SMALL_DEVICES} {
    display: none;
  }
`;

const HightailGamesSlogan = styled.div`
  font-size: 40px;
  font-weight: lighter;
`;

const GamesContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  ${SMALL_DEVICES} {
    align-items: center;
  }
`;

const GameCircleContainer = styled.div`
  margin-left: -10px;
`;

const GameTitle = styled.div`
  font-size: 32px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
`;

const GameDescription = styled.div`
  font-size: 18px;
  font-weight: normal;
  width: 70%;
  margin-bottom: 20px;
`;

const ButtonsContainer = styled.div`
  display: flex;
`;

const StoreButtonSpacing = styled.div`
  margin-right: 20px;
`;

export const MainSection: React.FC = () => {
  return (
    <Container>
      <HightailGamesSection>
        <div>
          <HightailGamesTitle>Hightail Games</HightailGamesTitle>
          <HightailGamesSlogan>Quality and Passion</HightailGamesSlogan>
        </div>
      </HightailGamesSection>

      <GamesContainer>
        <GameCircleContainer>
          <NavItem label="" path="/games">
            <GameCircle image={appLogo} width={250} height={250} />
          </NavItem>
        </GameCircleContainer>
        <GameTitle>{BATTLERUSH_ARENA_TITLE.toUpperCase()}</GameTitle>
        <GameDescription>
          {BATTLERUSH_ARENA_TITLE} is an online, competitive math game. Play against other people from
          around the world, obtain higher ranks, show off your brain power
          against your friends and family. Level your hero. Get epic weapons and
          armor and show everyone your own unique style.
        </GameDescription>
        <ButtonsContainer>
          <StoreButton storeName={"Play Store"} storeLogo={playStoreLogo} url={BATTLERUSH_ARENA_GOOGLE_PLAY_STORE_URL} />
          <StoreButtonSpacing />
          <StoreButton
            isInverted
            storeName={"App Store"}
            storeLogo={appStoreLogo}
            url={BATTLERUSH_ARENA_APP_STORE_URL}
          />
        </ButtonsContainer>
      </GamesContainer>
    </Container>
  );
};
